import { render, staticRenderFns } from "./create-game-service-category.vue?vue&type=template&id=0ea111cd&scoped=true&"
import script from "./create-game-service-category.vue?vue&type=script&lang=js&"
export * from "./create-game-service-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea111cd",
  null
  
)

export default component.exports